export default {
  getAppStatuses: (state) => state.appStatuses,
};
